var paymentCardLogos = [{
  alt: 'Argos card',
  imageLink: '//media.4rgos.it/i/Argos/footer-argos-card'
}, {
  alt: 'Visa card',
  imageLink: '//media.4rgos.it/i/Argos/footer-visa'
}, {
  alt: 'Master card',
  imageLink: '//media.4rgos.it/i/Argos/footer-mastercard'
}, {
  alt: 'American Express card',
  imageLink: '//media.4rgos.it/i/Argos/footer-american-express'
}, {
  alt: 'Apple Pay',
  imageLink: '//media.4rgos.it/i/Argos/footer-apple-pay'
}, {
  alt: 'Paypal',
  imageLink: '//media.4rgos.it/i/Argos/footer-paypal'
}, {
  alt: 'Klarna',
  imageLink: '//media.4rgos.it/i/Argos/footer-klarna'
}, {
  alt: 'Love 2 Shop Card',
  imageLink: '//media.4rgos.it/i/Argos/Love2Shop'
}, {
  alt: 'Argos Gift Card',
  imageLink: '//media.4rgos.it/i/Argos/ArgosGiftCard'
}, {
  alt: 'One4All Card',
  imageLink: '//media.4rgos.it/i/Argos/One4All'
}, {
  alt: 'Nectar Card',
  imageLink: '//media.4rgos.it/i/Argos/Nectar'
}];
export { paymentCardLogos };